import React, { Component, Fragment } from "react";
import "moment/locale/fr";
import { Alert, Button, DatePicker, Form, Input, message } from "antd";
import { assortmentApiUpsellProvider } from "../../../lib/api/providers";
import moment from "moment-timezone"
const FormItem = Form.Item;
const { RangePicker } = DatePicker;

class ImportClientAssortiment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: false,
      message: "",
      errors: [],
      results: [],
      file: ""
    };
  }

  componentDidMount() {
    this.props.getAllClients();
    this.props.getAllRetailers();
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {

      if (err) {
        console.log("err values", err, values);
        return;
      }

      let data = new FormData();
      data.append("assortmentLabel", values.assortmentLabel);
      data.append("endDate", typeof values["period"] !== "undefined" && values["period"][1].format("YYYY-MM-DD"));
      data.append("startDate", typeof values["period"] !== "undefined" && values["period"][0].format("YYYY-MM-DD"));
      data.append("file", this.state.file);
      data.append("client_id", this.props.currentClientId);

      if(this.props.model){
        data.append("model_id", this.props.model._id);
      }

      //TODO refactor !
      if (this.state.loading) {
        return;
      }

      this.setState({
        loading: true,
        message: "Importation en cours ...",
        error: false
      });
      assortmentApiUpsellProvider
        .post(`importAssortment`, data)
        .then(() => {
          this.setState({
            loading: false,
            message: "Importation réussie",
            error: false
          });

          message.success("Importation réussie");
        })
        .catch(e => {
          const response = e.response || {};
          const msg = response.data || "";

          this.setState({
            loading: false,
            message: `${msg}`,
            error: true
          });
        });
    });
  };
  normFile = e => {
    let fileList = e.fileList;
    fileList = fileList.slice(-1);
    if (Array.isArray(e)) {
      return e;
    }
    return e && fileList;
  };

  renderError() {
    const err = () => {
      return (
        <div style={{ maxHeight: 150, overflowY: "auto" }}>
          {this.state.message.split("\n").map((i, key) => {
            return (
              <div style={{ marginBottom: 5 }} key={key}>
                {i}
              </div>
            );
          })}
        </div>
      );
    };
    return (
      <div className="p-mrg-bot">
        <Alert message={"Echec de l'importation"} description={err()} type="error" showIcon />
      </div>
    );
  }

  onFileChange = e => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ file: files[0] });
  };

  render() {
    const { clientsList, retailersList, model } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0
        },
        sm: {
          span: 16,
          offset: 8
        }
      }
    };

    let periodicity = model && model.periodicity;

    return (
      <Fragment>
        {this.state.error ? this.renderError() : null}
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="Nom du modèle">
            {getFieldDecorator("assortmentLabel", {
              initialValue: model ? model.assortmentLabel : "",
              rules: [
                {
                  type: "string",
                  message: "Ce champ est incorrect"
                },
                {
                  required: true,
                  message: "Ce champ est obligatoire"
                }
              ]
            })(<Input />)}
          </FormItem>

          <FormItem {...formItemLayout} label="Période du modèle">
            {getFieldDecorator("period", {
              initialValue: periodicity ? [moment(periodicity.startDate), moment(periodicity.endDate)] : [],
              rules: [
                {
                  type: "array",
                  required: true,
                  message: "Ce champ est obligatoire"
                }
              ]
            })(<RangePicker />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Fichier excel" extra="Fichier .xlsx">
            <div>
              <input type="file" name="file" id="file" onChange={this.onFileChange} className="p-import-file" />
              <label htmlFor="file" className="p-import-btn">
                {this.state.file ? this.state.file.name : "Choisir un fichier"}
              </label>
            </div>
          </FormItem>
          <Button type="primary" htmlType="submit" loading={this.state.loading}>
            Submit
          </Button>
          {/* <InputSubmit type="submit" value="Importer" /> */}
        </Form>
      </Fragment>
    );
  }
}

export default Form.create()(ImportClientAssortiment);



// WEBPACK FOOTER //
// src/containers/admin/modeles/ImportModeleForm.js